"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Router_1 = require("@twii/router/lib/Router");
var UserProfileStore_1 = require("./model/UserProfileStore");
var UserHelper_1 = require("./UserHelper");
/**
 * Inject a user profile from the specified supplier
 * @param userProfileSupplier
 */
var injectUserProfile = function (userProfileSupplier) {
    if (userProfileSupplier === void 0) { userProfileSupplier = UserProfileStore_1.UserProfileStore; }
    return function (req, next) {
        if (!req.userProfile) {
            return userProfileSupplier.load().then(function () {
                if (userProfileSupplier.sync.error) {
                    return Promise.reject(userProfileSupplier.sync.error);
                }
                var nextReq = Object.assign({}, req, { userProfile: userProfileSupplier.value });
                next(nextReq);
            });
        }
        next();
    };
};
exports.injectUserProfile = injectUserProfile;
var userProfileFilter = function (filter, userProfileSupplier) {
    if (userProfileSupplier === void 0) { userProfileSupplier = UserProfileStore_1.UserProfileStore; }
    return function (req, next) {
        return userProfileSupplier.load().then(function () {
            if (userProfileSupplier.sync.error) {
                return Promise.reject(userProfileSupplier.sync.error);
            }
            var match = filter(userProfileSupplier.value);
            if (!match) {
                throw { code: "FORBIDDEN", message: "You do not have permission to access this resource", request: req };
            }
            return next();
        });
    };
};
exports.userProfileFilter = userProfileFilter;
var userProfileFilterRouter = function (filter, router, userProfileSupplier) {
    if (userProfileSupplier === void 0) { userProfileSupplier = UserProfileStore_1.UserProfileStore; }
    var r = new Router_1.Router();
    r.use(userProfileFilter(filter, userProfileSupplier));
    r.use(router);
    return r;
};
exports.userProfileFilterRouter = userProfileFilterRouter;
var requiresGroup = function (group, userProfileSupplier) {
    if (userProfileSupplier === void 0) { userProfileSupplier = UserProfileStore_1.UserProfileStore; }
    return userProfileFilter(function (userProfile) {
        return UserHelper_1.isMemberOfGroup(userProfile, group);
    }, userProfileSupplier);
};
exports.requiresGroup = requiresGroup;
var requiresGroupRouter = function (group, router, userProfileSupplier) {
    if (userProfileSupplier === void 0) { userProfileSupplier = UserProfileStore_1.UserProfileStore; }
    var r = new Router_1.Router();
    r.use(requiresGroup(group, userProfileSupplier));
    r.use(router);
    return r;
};
exports.requiresGroupRouter = requiresGroupRouter;
